import clsx from 'clsx';
import { Controller, useFormContext } from 'react-hook-form';

import { WrappedSelect } from '@quick/components/Forms';

import { useAppTranslation } from '@/app/i18n/client';

import { useFormDataContext } from './FormDataContext';
import type { IForm } from './types';
import { getNewAddress } from './utils';

export function Modality() {
  const { watch, setValue, control } = useFormContext<IForm>();

  const { serviceType } = useFormDataContext();

  const { t } = useAppTranslation(['common', 'demand']);

  const addresses = watch('stops');
  if (!serviceType) return null;
  return (
    <Controller
      control={control}
      name="modality_id"
      rules={{
        validate: (v) => {
          if (serviceType.modalities.length > 1 && !v)
            return t('common:msg.required_field');
        },
      }}
      render={({ field, fieldState: { error } }) => (
        <WrappedSelect
          isOnModal
          id="modality"
          {...field}
          label={t('common:modality')}
          requiredMark
          onChange={(e) => {
            field.onChange(e.target.value);
            if (!serviceType.comment_by_selection) {
              setValue(
                'stops',
                addresses.map((a) => ({ ...a, task: '' })),
                {
                  shouldDirty: true,
                }
              );
            }
            const selectedModality = serviceType?.modalities.find(
              ({ id }) => id.toString() === e.target.value
            );
            if (selectedModality?.single_address) {
              setValue('round_trip', false);
              setValue('stops', [addresses?.[0] ?? getNewAddress()], {
                shouldDirty: true,
              });
            } else if (addresses.length < 2) {
              setValue(
                'stops',
                [
                  addresses?.at(0) ?? getNewAddress(),
                  addresses?.at(1) ?? getNewAddress(),
                ],
                {
                  shouldDirty: true,
                }
              );
            }
          }}
          error={error?.message}
          className={clsx(serviceType.modalities.length <= 1 && 'hidden')}
        >
          <option hidden value="">
            {t('common:select_option')}
          </option>
          {serviceType?.modalities?.map(({ id, name }) => (
            <option key={id} value={id}>
              {name}
            </option>
          ))}
        </WrappedSelect>
      )}
    />
  );
}
